import search from '../../search.vue'
import Page from '../../page.vue'
import bookItem from '../../book.vue'
import {api} from "../../../common/config";
import {StorageUtil} from "../../../common/Auth";
import {ajaxUtil} from '../../../common/AjaxUtil.js';
import {CommonUtil} from '../../../common/CommonUtil.js';
import {store} from '../../../store/store.js'
export default {
  name: 'bookList',
  components: {
    Page,
    search,
    bookItem
  },
  data() {
    return {
      ajaxStatus: false,
      keywords: "",
      webType: store.webType,
      twoLevelCategoryId:0,
      typeId: 1, /*默认为图书，电子书为2*/
      bookCategorys: [], /*图书类型*/
      pageNo: 1,
      chooseItem: -1,
      activeTime: 0,
      categoryId: '',
      libId: '',
      libCode: '',
      totalPage: 1,
      pageCount: 8,
      books: [],
      resource: '',
      tabName:'最新上架',
      isPlay:true,
    }
  },
  watch: {
    $route(newVal, oldVal) {
      this.showData()
    }
  },
  beforeMount() {
    this.showData()
  },
  mounted() {
    if(this.typeId == 1) {
      store.wrap.activeRouteName = '图书'
    } else {
      store.wrap.activeRouteName = '电子书'
    }
    if(store.webType == 1) {
        this.tabName="本馆藏书";
    }
  },
  methods: {
    showData() {
      this.typeId = this.$route.params.type;
      this.chooseItem = this.$route.query.chooseItem!=undefined? this.$route.query.chooseItem : -1;
      this.activeTime = this.$route.query.activeTime || 0;
      this.categoryId = this.$route.query.categoryId || '';
      this.twoLevelCategoryId=this.$route.query.twoLevelCategoryId || 0;
      this.libId = this.$route.query.libId || 0;
      this.libCode = this.$route.query.hallCode || this.$route.query.libCode || '';
      this.pageNo = this.$route.query.page || 1;
      if(this.webType == 0){
          //平台图书和电子书
        if(this.typeId == 1) {
            // 图书
          this.resource='/searchbook';
          if(this.activeTime == 2) {
            this.books = [];
            Promise.all([this.category(api.book.category),this.weeklyHot(api.book.weeklyHot)])
          } else if(this.activeTime == 0){
            this.books = [];
            Promise.all([this.category(api.book.category),this.recommendationLibraryBook(api.book.recommendGoodBooks)])
          } else {
            this.books = [];
            Promise.all([this.category(api.book.category),this.getLastestCatalogue(api.book.lastestCatalogue)])
          }
        }else {
            // 电子书
          this.resource='/searchebook';
          if(this.activeTime == 2) {
            this.books = [];
            Promise.all([this.category(api.ebook.category),this.weeklyHotEbook(api.ebook.weeklyHot)])
          } else if(this.activeTime == 0){
            this.books = [];
            Promise.all([this.category(api.ebook.category),this.bookRecommendation(api.ebook.recommendGoodEBooks)])
           }else {
            this.books = [];
            Promise.all([this.category(api.ebook.category),this.getLastestCatalogueEbook(api.ebook.lastestCatalogue)])
          }
        }
      }else{   //图书馆图书和电子书
        if(this.typeId == 1) {
            // 图书
            this.resource='/searchbook';
            if(this.activeTime == 0){
                this.books = [];
                Promise.all([this.category(api.book.category),this.recommendationLibraryBook(api.book.recommendGoodBooks)])
           }else{
                Promise.all([this.category(api.book.category),this.bookBorrowing(api.book.borrowing)])
            }
        } else {
            this.books = [];
            // 电子书
            this.resource='/searchebook';
            if(this.activeTime == 0){
                Promise.all([this.category(api.ebook.category),this.bookRecommendation(api.ebook.recommendGoodEBooks)])
            }else{
                Promise.all([this.category(api.ebook.category),this.getLastestCatalogueEbook(api.ebook.lastestCatalogue)])
            }
        }
      }
    },
    weeklyHotEbook(param) {  //电子书一周热门
      this.ajaxStatus = true;
      var url;
      if(store.webType == 1) {
        url = param.replace('{pageNo}', Number(this.pageNo)).replace('{pageCount}', this.pageCount).replace('{categoryId}', this.categoryId)+"&twoLevelCategoryId="+this.twoLevelCategoryId+"&libCode="+this.libCode;
      } else {
        url = param.replace('{pageNo}', Number(this.pageNo)).replace('{pageCount}', this.pageCount).replace('{categoryId}', this.categoryId)+"&twoLevelCategoryId="+this.twoLevelCategoryId;
      }
      ajaxUtil.ajaxJson(url, null, "GET", (data)=> {
        this.books = data.resultList;
        this.ajaxStatus = false;
        this.totalPage = data.totalPage;
        this.pageNo = data.pageNo;
      }, null, this);
    },
   recommendationLibraryBook(param) {
        this.ajaxStatus = true;
        this.categoryId = !this.categoryId ? 0 : this.categoryId;
        let url;
        url = param.replace('{pageNo}', Number(this.pageNo)).replace('{pageCount}', this.pageCount).replace('{categoryId}', this.categoryId).replace('{libCode}', this.libCode);
        ajaxUtil.ajaxJson(url, null, "GET", (data)=> {
          this.books = data.resultList;
       if(this.books.length==0 && this.categoryId === 0){
           this.activeTime = 1;
           this.isPlay = false;
           this.ajaxStatus = true;
           this.getLastestCatalogue(api.book.lastestCatalogue)
       }else{
          this.ajaxStatus = false;
          this.totalPage = data.totalPage;
          this.pageNo = data.pageNo;
       }
        }, null, this);
      },

    getLastestCatalogueEbook(param) {  //电子书最新上架
      this.ajaxStatus = true;
      this.categoryId = this.categoryId == '' || !this.categoryId ? 0 : this.categoryId;
      var url;
      if(store.webType == 1) {
        url = param.replace('{pageNo}', Number(this.pageNo)).replace('{pageCount}', this.pageCount).replace('{oneLevelCategoryId}', this.categoryId)+'&twoLevelCategoryId='+Number(this.twoLevelCategoryId)+"&libCode="+this.libCode;
      } else {
        url = param.replace('{pageNo}', Number(this.pageNo)).replace('{pageCount}', this.pageCount).replace('{oneLevelCategoryId}', this.categoryId)+'&twoLevelCategoryId='+Number(this.twoLevelCategoryId);
      }
      ajaxUtil.ajaxJson(url, null, "GET", (data)=> {
        this.ajaxStatus = false;
        this.books = data.resultList;
        this.totalPage = data.totalPage;
        this.pageNo = data.pageNo;
      }, null, this);
    },

// 图书电子书推荐
    bookRecommendation(param){
        this.ajaxStatus = true;
        this.categoryId = this.categoryId == '' || !this.categoryId ? 0 : this.categoryId;
        // 0 图书馆 1 平台
       var url =  param.replace('{pageNo}', Number(this.pageNo)).replace('{pageCount}', this.pageCount).replace('{oneLevelCategoryId}', this.categoryId)+'&twoLevelCategoryId='+Number(this.twoLevelCategoryId)+"&libCode="+this.libCode;
            ajaxUtil.ajaxJson(url, null, "GET", (data)=> {
            this.books = data.resultList;
            if(this.books.length==0 && this.categoryId === 0 && Number(this.twoLevelCategoryId) === 0){
                this.isPlay=false
                this.activeTime=1;
                this.ajaxStatus = true;
                this.getLastestCatalogueEbook(api.ebook.lastestCatalogue)
            }else{
                this.ajaxStatus = false;
                this.totalPage = data.totalPage;
                this.pageNo = data.pageNo;
                this.activeTime==1;
            }
          }, null, this);
        },



    weeklyHot(param) { //图书一周热门
      this.ajaxStatus = true;
      if(store.webType == 1) {
        var url = param.replace('{pageNo}', Number(this.pageNo)).replace('{pageCount}', this.pageCount).replace('{categoryId}', this.categoryId)+"&libCode="+this.libCode;
      } else {
        var url = param.replace('{pageNo}', Number(this.pageNo)).replace('{pageCount}', this.pageCount).replace('{categoryId}', this.categoryId);
      }
      ajaxUtil.ajaxJson(url, null, "GET", (data)=> {
        this.ajaxStatus = false;
        this.books = data.resultList;
        this.totalPage = data.totalPage;
        this.pageNo = data.pageNo;
      }, null, this);
    },

    getLastestCatalogue(param) {  //图书最新上架
      this.ajaxStatus = true;
      this.categoryId=""
      if(store.webType == 1) {
        var url = param.replace('{pageNo}', Number(this.pageNo)).replace('{pageCount}', this.pageCount).replace('{categoryId}', this.categoryId)+"&libCode="+this.libCode;
      } else {
        var url = param.replace('{pageNo}', Number(this.pageNo)).replace('{pageCount}', this.pageCount).replace('{categoryId}', this.categoryId);
      }
      ajaxUtil.ajaxJson(url, null, "GET", (data)=> {
        this.ajaxStatus = false;
        this.books = data.resultList;
        this.totalPage = data.totalPage;
        this.pageNo = data.pageNo;
      }, null, this);
    },

    bookBorrowing(param){   //图书馆图书借阅量排行
      this.ajaxStatus = true;
      var url = param.replace('{libCode}', this.libCode).replace('{pageNo}', Number(this.pageNo)).replace('{pageCount}', this.pageCount).replace('{categoryId}', this.categoryId);
      ajaxUtil.ajaxJson(url, null, "GET", (data)=> {
        this.ajaxStatus = false;
        this.books = data.resultList;
        this.totalPage = Math.ceil(data.totalCount / this.pageCount);
        this.pageNo = data.pageNo;
      }, null, this);
    },

    /*目录*/
    category(param) {
       ajaxUtil.ajaxJson(param, null, "GET", (data)=> {
         this.bookCategorys = data;
         this.bookCategorys.forEach((item, index)=>{
          item.subListId = [];
          if(item.subList) {
            for(var i = 0; i < item.subList.length; i++) {
              item.subListId.push(String(item.subList[i].categoryId))
            }
          }
        })
      }, null, this);
    },
    /**
     * 页面跳转和搜索
     */
    search(keywordInput) {
      var searchStr=keywordInput.trim();
      if(searchStr=="" || searchStr.length==0){
        return;
      }
      this.$router.push({path: '/indexsearch', query: {searchStr: searchStr,type:this.typeId,code:store.chooseArea.code,fromSearch:1,hallCode: this.libCode}});
    },
    toChooseItem(index) {
      this.chooseItem = index == this.chooseItem?-1:index;
    },
    highSearch(){
      var searchType=this.typeId;
      if (searchType == 1) {
        this.$router.push({path: '/searchbook', query: {type: 1,"fromSearch":1,hallCode: this.libCode, typeId:0}});
      } else if (searchType == 2) {
        this.$router.push({path: '/searchbook', query: {type: 1,"fromSearch":1,hallCode: this.libCode, typeId:1}});
      }
    },
    //切换热门
    changeTime(type) {
      StorageUtil.storeString("activeTime",type)
      CommonUtil.mergeQuery(this,{page: 1,categoryId:this.categoryId, activeTime: type,chooseItem: this.chooseItem})
    },
    //点击分类
    categoryChange(id) {
      if(id == '') {
        this.chooseItem = -1;
      }
      this.categoryId=id;
      this.twoLevelCategoryId=0;
      CommonUtil.mergeQuery(this,{page: 1,categoryId: id,twoLevelCategoryId:0,activeTime: this.activeTime,chooseItem: this.chooseItem})
    },
    subCategoryChange(id,subId){
      if(id == '') {
        this.chooseItem = -1;
      }
      this.categoryId = id;
      this.twoLevelCategoryId=subId;
      CommonUtil.mergeQuery(this,{page: 1,categoryId: id,twoLevelCategoryId:subId, activeTime: this.activeTime,chooseItem: this.chooseItem})
    },
    //翻页操作
    pageChange(pageNo) {
      CommonUtil.mergeQuery(this,{page: pageNo})
    },

  }
}
